import { useQuery } from '@tanstack/react-query'

import config from '@config'
import { EntityType, SportEntity } from '@utils/entities'

type UseEntitySubscriptionsProps = {
  enabled?: boolean
  entityType: EntityType
} & { signal?: AbortSignal }

export type SportEntitySubscription = SportEntity & {
  channel: string | null
}

export type SportEntitySubscriptionsAPIResponse = SportEntitySubscription[]

const {
  nemosyne: { baseUrl, getAllEntitySubscriptionsUrl },
} = config

const fetchEntitySubscriptionsData = async ({
  entityType,
  signal,
}: UseEntitySubscriptionsProps) => {
  const response = await fetch(
    `${baseUrl}${getAllEntitySubscriptionsUrl.replace('{ENTITY_TYPE}', entityType)}`,
    {
      credentials: 'include',
      signal,
    }
  )

  if (!response.ok) {
    throw new Error('Error fetching entity subscriptions data.')
  }

  return response.json() as Promise<SportEntitySubscriptionsAPIResponse>
}

const useSportEntitySubscriptions = ({
  enabled,
  entityType,
}: UseEntitySubscriptionsProps) => {
  return useQuery({
    queryKey: ['sport-entity-subscriptions', entityType],
    queryFn: async ({ signal }) =>
      fetchEntitySubscriptionsData({
        entityType,
        signal,
      }),
    enabled,
  })
}

export default useSportEntitySubscriptions
